import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@pinpoint/design-kit';
import DefaultTheme from 'src/styles/DefaultTheme';

const StyledButton = styled(Button)`
  :active {
    background-color: ${({ disabled }) => (!disabled ? DefaultTheme.colors.grey900 : '')};
  }
`;

function AdminButton({ selected, children, ...userProps }) {
  return (
    <StyledButton
      bg={selected ? 'grey700' : 'grey900'}
      hoverBg={selected ? '' : 'grey600'}
      m={{ r: '0.5rem' }}
      p={{ x: '0.75rem' }}
      h="1.875rem"
      cursor={selected ? 'initial' : 'pointer'}
      {...userProps}
    >
      {children}
    </StyledButton>
  );
}

AdminButton.defaultProps = {
  selected: null,
  children: null,
};

AdminButton.propTypes = {
  selected: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default AdminButton;
